/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

//The tracked agents what we're seeing within pagination buttons
import ConversationTableFooterGuide from "./sub/ConversationTableFooterGuide/index"

import "./ConversationTableFooter.scss";

function index({
  total,
  qtd,
  page,
  handlePreviousPage,
  handleNextPage
}) {
  return (
    <div className="d-flex justify-content-end mr-3 mb-3">
      <ConversationTableFooterGuide
        pageConversationsNumber={page}
        qtdConversationsNumber={qtd}
        totalConversationsNumber={total}
      />
      <Pagination
        aria-label="agents-founded"
        className="d-flex justify-content-around mt-2"
      >
        <PaginationItem onClick={(e) => handlePreviousPage(e)}>
          <PaginationLink previous />
        </PaginationItem>

        <PaginationItem className="page-item-fixed-size" active>
          <PaginationLink> {page} </PaginationLink>
        </PaginationItem>

        <PaginationItem onClick={(e) => handleNextPage(e)}>
          <PaginationLink next />
        </PaginationItem>
      </Pagination>
    </div>
  );
}

export default index;
